import { AllocationAcknowledgement } from '../../../../../../../../graphql';

export const AllocationAcknowledgementStatusLabel = {
  [AllocationAcknowledgement.Unacknowledged]: 'Awaiting Response',
  [AllocationAcknowledgement.Acknowledged]: 'Acknowledged',
  [AllocationAcknowledgement.Rejected]: 'Rejected',
};
